import * as XLSX from 'xlsx';
import dayjs from 'dayjs';
import axios from '../utils/axios';

const pathPrefix = `${process.env.REACT_APP_SERVER_URL}/api`;

type AbsenceInput = {
  Name: string;
  Date: string | number;
  'Leave Type': string;
};

type AbsenceOutput = {
  name: string;
  month: number;
  hours: number;
  ignoredHours: number;
};

const allowedAbsentifyType = [
  "wypoczynkowy urlop",
  "zwolnienie lekarskie",
  "niepełny etat",
  "macierzyński urlop",
  "ojcowski urlop",
  "okolicznościowy urlop",
  "bezpłatny urlop",
  "dzień wolny za święto",
  "Przerwa w świadczeniu usług (B2B, UZ)"
];

export const importExcelAndSend = async (file: File, year: number): Promise<void> => {
  try {
    const buffer = await file.arrayBuffer();
    const workbook = XLSX.read(buffer, { type: 'array' });
    const sheetName = 'Absences per day';
    const sheet = workbook.Sheets[sheetName];

    if (!sheet) {
      throw new Error(`Nie znaleziono arkusza: ${sheetName}`);
    }

    const data: AbsenceInput[] = XLSX.utils.sheet_to_json(sheet);
    console.log(`Wczytano ${data.length} wierszy z Excela`);

    const resultMap: Map<string, { hours: number; ignoredHours: number }> = new Map();

    data.forEach((entry) => {
      const leaveType = entry['Leave Type'];
      if (!leaveType) return;

      const name = entry.Name;
      let parsedDate: dayjs.Dayjs;

      if (typeof entry.Date === 'number') {
        const excelDate = new Date(Math.round((entry.Date - 25569) * 86400 * 1000));
        parsedDate = dayjs(excelDate);
      } else {
        parsedDate = dayjs(entry.Date, 'MM.DD.YYYY');
      }

      if (!parsedDate.isValid()) {
        console.warn(`Nieprawidłowa data u "${name}": ${entry.Date}`);
        return;
      }

      const month = parsedDate.month() + 1;
      const key = `${name}::${month}`;
      const current = resultMap.get(key) || { hours: 0, ignoredHours: 0 };

      if (allowedAbsentifyType.find(x => x.toLowerCase() === leaveType.toLowerCase())) {
        current.hours += 8;
      } else {
        current.ignoredHours += 8;
      }

      resultMap.set(key, current);
    });

    const result: AbsenceOutput[] = Array.from(resultMap.entries()).map(([key, stats]) => {
      const [name, monthStr] = key.split('::');
      return {
        name: name,
        month: parseInt(monthStr, 10),
        hours: stats.hours,
        ignoredHours: stats.ignoredHours
      };
    });

    console.log(`Przygotowano ${result.length} rekordów do wysłania do API`);
    console.table(result);

    const apiUrl = `${pathPrefix}/Absentify?year=${year}`;
    console.log(`Wysyłanie danych do: ${apiUrl}`);

    const response = await axios.put(apiUrl, result, {
      headers: { 'Content-Type': 'application/json' },
    });

    console.log("Dane zostały pomyślnie wysłane:", response.data);
  } catch (error: any) {
    console.error("Błąd podczas importu i wysyłki:", error.message || error);
    throw error;
  }
};

export const fetchLastUpdated = async (year: number): Promise<string> => {
  try {
    const url = `${pathPrefix}/Absentify/last-updated?year=${year}`;
    const res = await axios.get(url);
    return res.data.updated;
  } catch (err: any) {
    console.error("Błąd podczas pobierania daty aktualizacji:", err.message || err);
    throw err;
  }
};
